/* eslint-disable react/display-name */
import { lazy } from "react";

const CrossbeltDevicePage = lazy(() => import("./pages/crossbelt-device"));
const CrossbeltCabinetPage = lazy(() => import("./pages/cabinet"));
const CrossbeltCameraConfigPage = lazy(() => import("./pages/camera-config"));

const BombayStatisticPage = lazy(() => import("../wms/pages/bombay/statistic"));
const BombayChutePage = lazy(() => import("../wms/pages/bombay/chute"));
const BombayCarrierPage = lazy(() => import("../wms/pages/bombay/carrier"));
const BombayInductionPage = lazy(() => import("../wms/pages/bombay/induction"));
const BombayOperationConfigPage = lazy(
  () => import("../wms/pages/bombay/operation-config")
);
const BombayPlanPage = lazy(() => import("../wms/pages/bombay/plan"));
const BombayPlanConfigPage = lazy(
  () => import("../wms/pages/bombay/plan-config")
);

const CrossbeltBombayRoutes = [
  { path: "devices", element: <CrossbeltDevicePage /> },
  { path: "cabinet", element: <CrossbeltCabinetPage /> },
  { path: "camera-config", element: <CrossbeltCameraConfigPage /> },

  { path: "bombay/statistic", element: <BombayStatisticPage /> },
  { path: "bombay/chute", element: <BombayChutePage /> },
  { path: "bombay/carrier", element: <BombayCarrierPage /> },
  { path: "bombay/induction", element: <BombayInductionPage /> },
  { path: "bombay/operation-config", element: <BombayOperationConfigPage /> },
  { path: "bombay/plan", element: <BombayPlanPage /> },
  { path: "bombay/plan/:planId", element: <BombayPlanConfigPage /> }
];
export default CrossbeltBombayRoutes;
